import React from 'react';
import Navbar from '../components/navbar/navbar';
import Index from '../components/product';

const Product = () => {
    return (
        <div className='bg-dark'>
            <Navbar/>
            <Index/>
        </div>
    );
}

export default Product;
